"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEST_STRING_MATCH = exports.TEST_CONTENT_FRAGMENT_ID = exports.TEST_CONTENT_FRAGMENT = void 0;
const TEST_CONTENT_FRAGMENT = exports.TEST_CONTENT_FRAGMENT = `
<h1>Some HTML for Unit Testing</h1>
<p>Target the string __test__ with your unit test.</p>
`;
const TEST_CONTENT_FRAGMENT_ID = exports.TEST_CONTENT_FRAGMENT_ID = "1nrodlk";
const TEST_STRING_MATCH = exports.TEST_STRING_MATCH = "__TEST__";